"use client";

import { useEffect, useRef } from "react";
import {
  sendProductViewed,
  type ProductViewedSegmentParams,
} from "@/lib/segment/sendProductViewed";

/**
 * Fires Segment `edx.bi.ecommerce.product_viewed` when the PDP client mounts
 * (and again if `product_id` changes).
 */
export default function SegmentProductView(props: ProductViewedSegmentParams) {
  const payloadRef = useRef(props);
  payloadRef.current = props;

  useEffect(() => {
    sendProductViewed(payloadRef.current);
  }, [props.product_id]);

  return null;
}
